<template>
  <v-card>
    <v-app-bar color="primary" dark elevation="0">
      <v-toolbar-title> <v-icon color="white" left> mdi-test-tube</v-icon> Test Types </v-toolbar-title>
      <v-spacer />
      <slot name="headerTableRight"></slot>
    </v-app-bar>
    <v-card-title class="primary--text">
      <v-spacer></v-spacer>
      <v-text-field v-model="searchTable" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      @click:row="handleClick"
      class="elevation-1 test-type-table-component"
      :items-per-page="-1"
      hide-default-footer
      :items="testTypes"
      :search="searchTable"
      :sort-by="['name']"
    >
      <template v-slot:body="{ items }">
        <tbody v-if="items.length > 0">
          <tr :class="'row-class row-class-' + item.id" v-for="item in items" :key="item.id" @click="handleClick(item)">
            <td>{{ item.name }}</td>
            <td>{{ item.prefix }}</td>
            <td>{{ item.type }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <template v-if="loading">
      <v-skeleton-loader
        v-for="(page, i) in 20"
        :key="'skeletonloader-' + i"
        type="list-item"
        ref="skeleton"
        class="mx-auto my-0"
      ></v-skeleton-loader>
    </template>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      testTypes: 'testTypeStore/testTypes'
    })
  },
  created() {
    this.getTestTypes();
  },
  data() {
    return {
      loading: false,
      searchTable: null,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Type', value: 'type' }
      ]
    };
  },
  methods: {
    handleClick(value) {
      this.$emit('itemClicked', value);
    },
    async getTestTypes() {
      this.loading = true;
      await this.$store.dispatch('testTypeStore/getTestTypes');
      this.loading = false;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    }
  }
};
</script>

<style lang="scss">
</style>